export default __webpack_public_path__ + "media/components/Header/Images/Text_normal-053c3c75a555764b8fc5afe66fd45be3.svg";